/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsFormDropoffAnalytics } from '../../axios/analyticsFormDropoffAnalytics'
import type {
	AnalyticsFormDropoffAnalyticsError,
	AnalyticsFormDropoffAnalyticsPathParams,
	AnalyticsFormDropoffAnalyticsQueryParams,
	AnalyticsFormDropoffAnalyticsResponse,
} from '../../types/AnalyticsFormDropoffAnalytics'

export const analyticsFormDropoffAnalyticsQueryKey = (
	campaign: AnalyticsFormDropoffAnalyticsPathParams['campaign'],
	params?: AnalyticsFormDropoffAnalyticsQueryParams,
) => [
	{ url: '/campaigns/:campaign/form-dropoff-analytics', params: { campaign } },
	...(params ? [params] : []),
] as const

export type AnalyticsFormDropoffAnalyticsQueryKey = ReturnType<typeof analyticsFormDropoffAnalyticsQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::formDropoffAnalytics */
export function analyticsFormDropoffAnalyticsQueryOptions(
	campaign: AnalyticsFormDropoffAnalyticsPathParams['campaign'],
	params?: AnalyticsFormDropoffAnalyticsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsFormDropoffAnalyticsResponse,
		AxiosError<AnalyticsFormDropoffAnalyticsError>,
		AnalyticsFormDropoffAnalyticsResponse,
		AnalyticsFormDropoffAnalyticsQueryKey
	>({
		queryKey: analyticsFormDropoffAnalyticsQueryKey(campaign, params),
		queryFn: ({ signal }) =>
			analyticsFormDropoffAnalytics(campaign, params, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::formDropoffAnalytics */
export function useAnalyticsFormDropoffAnalytics<TSelectData = AnalyticsFormDropoffAnalyticsResponse>(
	campaign: AnalyticsFormDropoffAnalyticsPathParams['campaign'],
	params?: AnalyticsFormDropoffAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsFormDropoffAnalyticsResponse,
					AxiosError<AnalyticsFormDropoffAnalyticsError>,
					TSelectData,
					AnalyticsFormDropoffAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsFormDropoffAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsFormDropoffAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::formDropoffAnalytics */
export function useAnalyticsFormDropoffAnalyticsSuspense<TSelectData = AnalyticsFormDropoffAnalyticsResponse>(
	campaign: AnalyticsFormDropoffAnalyticsPathParams['campaign'],
	params?: AnalyticsFormDropoffAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsFormDropoffAnalyticsResponse,
					AxiosError<AnalyticsFormDropoffAnalyticsError>,
					TSelectData,
					AnalyticsFormDropoffAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsFormDropoffAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsFormDropoffAnalyticsQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
